/**
 * Do not edit directly
 * Generated on Thu, 13 Nov 2025 14:20:01 GMT
 */

var BORDER_RADIUS_100 = "1px";
var BORDER_RADIUS_200 = "2px";
var BORDER_RADIUS_300 = "4px";
var BORDER_RADIUS_400 = "6px";
var BORDER_RADIUS_500 = "8px";
var BORDER_RADIUS_600 = "12px";
var BORDER_RADIUS_700 = "16px";
var BORDER_RADIUS_800 = "20px";
var BORDER_RADIUS_900 = "24px";
var BORDER_RADIUS_NONE = "0";
var BORDER_RADIUS_PILL = "100%";
var BORDER_RADIUS_CARD = "8px";
var BORDER_RADIUS_FULL_OR_NONE = "100%";
var COLOR_ALMOSTBLACK = "#202020";
var COLOR_BLACK = "#202020";
var COLOR_WHITE = "#FFFFFF";
var COLOR_STEEL_BLUE = "#799094";
var COLOR_DARK_STEEL_BLUE = "#567278";
var COLOR_PLANT = "#667f73";
var COLOR_CLAY = "#d3bfac";
var COLOR_SANDSTONE = "#7d726a";
var COLOR_WAVE = "#3d6778";
var COLOR_LIGHT_TEAL = "#b0ccca";
var COLOR_SILVER = "#d6e2e5";
var COLOR_MANGO = "#f6b637";
var COLOR_LIGHT_SAND = "#f9f5f1";
var COLOR_OCEAN = "#359cbb";
var COLOR_OCEAN_L1 = "#60b9d4";
var COLOR_DARK_GRAY = "#454545";
var COLOR_DARK_GRAY_L1 = "#707070";
var COLOR_MEDIUM_GRAY = "#adadad";
var COLOR_MEDIUM_GRAY_L1 = "#c7c7c7";
var COLOR_LIGHT_GRAY = "#e3e3e3";
var COLOR_LIGHT_GRAY_L1 = "#ededed";
var COLOR_EXTRA_LIGHT_GRAY = "#f7f7f7";
var COLOR_DARK_CORE_100 = "#FFDAB9";
var COLOR_DARK_CORE_200 = "#FFC49A";
var COLOR_DARK_CORE_300 = "#FFAD7A";
var COLOR_DARK_CORE_400 = "#FF8640";
var COLOR_DARK_CORE_500 = "#FF5E00";
var COLOR_DARK_CORE_600 = "#E15300";
var COLOR_DARK_CORE_700 = "#C44800";
var COLOR_DARK_CORE_800 = "#A63C10";
var COLOR_DARK_CORE_900 = "#8B2E16";
var COLOR_CORE_100 = "#FFEBD6";
var COLOR_CORE_200 = "#FFD4A8";
var COLOR_CORE_300 = "#FFB876";
var COLOR_CORE_400 = "#FFA348";
var COLOR_CORE_500 = "#FE8C00";
var COLOR_CORE_600 = "#E77E00";
var COLOR_CORE_700 = "#D07000";
var COLOR_CORE_800 = "#B86100";
var COLOR_CORE_900 = "#A35300";
var COLOR_CORE_SUNRISE = "#FE8C00";
var COLOR_SUNLIGHT_100 = "#FFF8BF";
var COLOR_SUNLIGHT_200 = "#FFF496";
var COLOR_SUNLIGHT_300 = "#FFEC88";
var COLOR_SUNLIGHT_400 = "#FFE566";
var COLOR_SUNLIGHT_500 = "#FFD940";
var COLOR_SUNLIGHT_600 = "#FFCC02";
var COLOR_SUNLIGHT_700 = "#FFC123";
var COLOR_SUNLIGHT_800 = "#F6AE00";
var COLOR_SUNLIGHT_900 = "#E5A302";
var COLOR_TEAL_100 = "#E6F4F4";
var COLOR_TEAL_200 = "#DDEFF0";
var COLOR_TEAL_300 = "#CBE5E5";
var COLOR_TEAL_400 = "#B9DBDC";
var COLOR_TEAL_500 = "#A5D5D8";
var COLOR_TEAL_600 = "#81BEC3";
var COLOR_TEAL_700 = "#6A9FA3";
var COLOR_TEAL_800 = "#4C7F81";
var COLOR_TEAL_900 = "#2E696C";
var COLOR_OLIVE_100 = "#ECEFE3";
var COLOR_OLIVE_200 = "#E6EADA";
var COLOR_OLIVE_300 = "#D9E0C7";
var COLOR_OLIVE_400 = "#CDD5B5";
var COLOR_OLIVE_500 = "#C0CBA2";
var COLOR_OLIVE_600 = "#A1AB87";
var COLOR_OLIVE_700 = "#8A9559";
var COLOR_OLIVE_800 = "#70763D";
var COLOR_OLIVE_900 = "#606534";
var COLOR_SAND_100 = "#FAF6F1";
var COLOR_SAND_200 = "#F6EEE5";
var COLOR_SAND_300 = "#EEE1D2";
var COLOR_SAND_400 = "#EED7B9";
var COLOR_SAND_500 = "#E4C6A0";
var COLOR_SAND_600 = "#C4A175";
var COLOR_SAND_700 = "#A98A63";
var COLOR_SAND_800 = "#8E7352";
var COLOR_SAND_900 = "#715C42";
var COLOR_GRASS_100 = "#95D59B";
var COLOR_GRASS_200 = "#83CA8A";
var COLOR_GRASS_300 = "#5EB366";
var COLOR_GRASS_400 = "#3A9D43";
var COLOR_GRASS_500 = "#158620";
var COLOR_GRASS_600 = "#116B1A";
var COLOR_GRASS_700 = "#0D5013";
var COLOR_GRASS_800 = "#08360D";
var COLOR_GRASS_900 = "#052409";
var COLOR_ROUGE_100 = "#FFCDCB";
var COLOR_ROUGE_200 = "#FFBDBA";
var COLOR_ROUGE_300 = "#FF9B97";
var COLOR_ROUGE_400 = "#FF7A75";
var COLOR_ROUGE_500 = "#FF5A52";
var COLOR_ROUGE_600 = "#D44942";
var COLOR_ROUGE_700 = "#A93731";
var COLOR_ROUGE_800 = "#7F2521";
var COLOR_ROUGE_900 = "#611C19";
var COLOR_APRICOT_500 = "#FDD587";
var COLOR_SALMON_500 = "#C9372C";
var COLOR_MINT_GREEN_500 = "#20845A";
var COLOR_ALERT_500 = "#F6CC47";
var COLOR_SUCCESS_500 = "#20845A";
var COLOR_ERROR_500 = "#C9372C";
var COLOR_QUARTZ_50 = "#F6F4EF";
var COLOR_QUARTZ_100 = "#F1EEE7";
var COLOR_QUARTZ_150 = "#EDE8DE";
var COLOR_QUARTZ_200 = "#E8E2D6";
var COLOR_QUARTZ_250 = "#CEC7BA";
var COLOR_QUARTZ_300 = "#B4AB9E";
var COLOR_QUARTZ_350 = "#9A9082";
var COLOR_QUARTZ_400 = "#807566";
var COLOR_QUARTZ_450 = "#766D61";
var COLOR_QUARTZ_500 = "#6C665B";
var COLOR_QUARTZ_550 = "#625E56";
var COLOR_QUARTZ_600 = "#56514A";
var COLOR_QUARTZ_650 = "#49453E";
var COLOR_QUARTZ_700 = "#3D3832";
var COLOR_PYRIGHT_LIGHT_100 = "#E6E1D0";
var COLOR_PYRIGHT_LIGHT_200 = "#DCD6BE";
var COLOR_PYRIGHT_LIGHT_300 = "#D3C9AC";
var COLOR_PYRIGHT_LIGHT_400 = "#C9BC9B";
var COLOR_PYRIGHT_LIGHT_500 = "#C0AF89";
var COLOR_PYRIGHT_LIGHT_600 = "#A39474";
var COLOR_PYRIGHT_LIGHT_700 = "#867860";
var COLOR_PYRIGHT_LIGHT_800 = "#6A5E4B";
var COLOR_PYRIGHT_LIGHT_900 = "#4D4437";
var COLOR_PYRIGHT_DARK_100 = "#E3DCB8";
var COLOR_PYRIGHT_DARK_200 = "#C7C09D";
var COLOR_PYRIGHT_DARK_300 = "#ACA583";
var COLOR_PYRIGHT_DARK_400 = "#918A69";
var COLOR_PYRIGHT_DARK_500 = "#777151";
var COLOR_PYRIGHT_DARK_600 = "#5E593A";
var COLOR_PYRIGHT_DARK_700 = "#464124";
var COLOR_PYRIGHT_DARK_800 = "#2F2B0F";
var COLOR_PYRIGHT_DARK_900 = "#1A1700";
var COLOR_LARIMAR_LIGHT_100 = "#EFF7F5";
var COLOR_LARIMAR_LIGHT_200 = "#D8EBE6";
var COLOR_LARIMAR_LIGHT_300 = "#BFD4CF";
var COLOR_LARIMAR_LIGHT_400 = "#A7BDB8";
var COLOR_LARIMAR_LIGHT_500 = "#90A7A1";
var COLOR_LARIMAR_LIGHT_600 = "#7A908B";
var COLOR_LARIMAR_LIGHT_700 = "#657974";
var COLOR_LARIMAR_LIGHT_800 = "#50635E";
var COLOR_LARIMAR_LIGHT_900 = "#3C4C48";
var COLOR_LARIMAR_DARK_100 = "#D1F0F4";
var COLOR_LARIMAR_DARK_200 = "#B5D4D8";
var COLOR_LARIMAR_DARK_300 = "#9AB8BC";
var COLOR_LARIMAR_DARK_400 = "#7F9DA1";
var COLOR_LARIMAR_DARK_500 = "#668387";
var COLOR_LARIMAR_DARK_600 = "#4D6A6E";
var COLOR_LARIMAR_DARK_700 = "#365255";
var COLOR_LARIMAR_DARK_800 = "#1F3B3E";
var COLOR_LARIMAR_DARK_900 = "#082528";
var COLOR_MORGANITE_100 = "#F0DDD6";
var COLOR_MORGANITE_200 = "#EAD0C7";
var COLOR_MORGANITE_300 = "#E4C3B8";
var COLOR_MORGANITE_400 = "#DFB6A8";
var COLOR_MORGANITE_500 = "#D9A999";
var COLOR_MORGANITE_600 = "#B99082";
var COLOR_MORGANITE_700 = "#98766B";
var COLOR_MORGANITE_800 = "#775D54";
var COLOR_MORGANITE_900 = "#57443D";
var COLOR_GREY_25 = "#F7F7F7";
var COLOR_GREY_50 = "#F0F1F2";
var COLOR_GREY_100 = "#E3E3E3";
var COLOR_GREY_200 = "#D6D6D6";
var COLOR_GREY_300 = "#C6C6C6";
var COLOR_GREY_400 = "#ADADAD";
var COLOR_GREY_500 = "#8F8F8F";
var COLOR_GREY_600 = "#737373";
var COLOR_GREY_700 = "#5E5E5E";
var COLOR_GREY_800 = "#505050";
var COLOR_GREY_900 = "#202020";
var COLOR_GREEN_100 = "#D9ECCE";
var COLOR_GREEN_200 = "#B3D99D";
var COLOR_GREEN_300 = "#8DC56D";
var COLOR_GREEN_400 = "#67B23C";
var COLOR_GREEN_500 = "#419F0B";
var COLOR_GREEN_600 = "#347F09";
var COLOR_GREEN_700 = "#275F07";
var COLOR_GREEN_800 = "#1A4004";
var COLOR_GREEN_900 = "#133003";
var COLOR_RUBY_100 = "#FF876B";
var COLOR_RUBY_200 = "#FF6B52";
var COLOR_RUBY_300 = "#EB4E3A";
var COLOR_RUBY_400 = "#CB3023";
var COLOR_RUBY_500 = "#AB030C";
var COLOR_RUBY_600 = "#8C0000";
var COLOR_RUBY_700 = "#6D0000";
var COLOR_RUBY_800 = "#4E0001";
var COLOR_RUBY_900 = "#320002";
var COLOR_TURMERIC_100 = "#FEF1D7";
var COLOR_TURMERIC_200 = "#FEE3AF";
var COLOR_TURMERIC_300 = "#FDD587";
var COLOR_TURMERIC_400 = "#FDC75F";
var COLOR_TURMERIC_500 = "#FCB937";
var COLOR_TURMERIC_600 = "#CA942C";
var COLOR_TURMERIC_700 = "#B08227";
var COLOR_TURMERIC_800 = "#7E5D1C";
var COLOR_TURMERIC_900 = "#4C3710";
var COLOR_EARTH = "#746343";
var COLOR_LINK = "#359cbb";
var COLOR_LINK_HOVER = "#359cbb";
var COLOR_CTA_PRIMARY = "#FF5E00";
var COLOR_CTA_PRIMARY_HOVER = "#E15300";
var COLOR_CTA_PRIMARY_ACTIVE = "#C44800";
var COLOR_CTA_SECONDARY = "#4C7F81";
var COLOR_CTA_SECONDARY_HOVER = "#2E696C";
var COLOR_CTA_SECONDARY_ACTIVE = "#2E696C";
var COLOR_CTA_LINK_PRIMARY = "#C44800";
var COLOR_CTA_LINK_PRIMARY_HOVER = "#A63C10";
var COLOR_CTA_LINK_SECONDARY = "#202020";
var COLOR_CTA_LINK_SECONDARY_HOVER = "#202020";
var COLOR_CTA_BUTTON_PRIMARY = "#FF5E00";
var COLOR_CTA_BUTTON_PRIMARY_HOVER = "#E15300";
var COLOR_CTA_BUTTON_PRIMARY_ACTIVE = "#C44800";
var COLOR_CTA_BUTTON_PRIMARY_DARK = "#202020CC";
var COLOR_CTA_BUTTON_PRIMARY_DARK_HOVER = "#737373CC";
var COLOR_CTA_BUTTON_PRIMARY_DARK_ACTIVE = "#737373CC";
var COLOR_CTA_BUTTON_SECONDARY = "#FF5E00";
var COLOR_CTA_BUTTON_SECONDARY_HOVER = "#E15300";
var COLOR_CTA_BUTTON_SECONDARY_ACTIVE = "#C44800";
var COLOR_CTA_BUTTON_SECONDARY_DARK = "#202020";
var COLOR_CTA_BUTTON_SECONDARY_DARK_HOVER = "#202020";
var COLOR_CTA_BUTTON_SECONDARY_DARK_ACTIVE = "#202020";
var COLOR_CTA_BUTTON_SECONDARY_LIGHT = "#FFFFFF";
var COLOR_CTA_BUTTON_SECONDARY_LIGHT_HOVER = "#FFFFFF";
var COLOR_CTA_BUTTON_SECONDARY_LIGHT_ACTIVE = "#FFFFFF";
var COLOR_CTA_BUTTON_TERTIARY = "#4C7F81";
var COLOR_CTA_BUTTON_TERTIARY_HOVER = "#2E696C";
var COLOR_CTA_BUTTON_TERTIARY_ACTIVE = "#2E696C";
var COLOR_CTA_BUTTON_GHOST = "#202020";
var COLOR_BACKGROUND_BODY = "#FAF6F1";
var COLOR_BACKGROUND_SURFACE_PRIMARY = "#FFFFFF";
var COLOR_BACKGROUND_SURFACE_SECONDARY = "#EEE1D2";
var COLOR_BACKGROUND_SURFACE_TERTIARY = "#202020";
var COLOR_BACKGROUND_DISABLED = "#E3E3E3";
var COLOR_TEXT = "#202020";
var COLOR_TEXT_SUBTLE = "#505050";
var COLOR_TEXT_INVERSE = "#FFFFFF";
var COLOR_TEXT_DISABLED = "#8F8F8F";
var COLOR_TEXT_PRIMARY = "#202020";
var COLOR_BORDER_KEY_LINE = "#C6C6C6";
var COLOR_BORDER_PRIMARY = "#8F8F8F";
var COLOR_BORDER_SECONDARY = "#ADADAD";
var COLOR_BORDER_DISABLED = "#8F8F8F";
var COLOR_BORDER_BRAND = "#FF5E00";
var COLOR_CAMPAIGN_GOOD_PRIMARY = "#FFB876";
var COLOR_CAMPAIGN_GOOD_SECONDARY = "#FFD4A8";
var COLOR_CAMPAIGN_GOOD_TERTIARY = "#FFEBD6";
var COLOR_CAMPAIGN_BETTER_PRIMARY = "#2E696C";
var COLOR_CAMPAIGN_BETTER_SECONDARY = "#4C7F81";
var COLOR_CAMPAIGN_BEST_PRIMARY = "#FF5A52";
var COLOR_CAMPAIGN_BLACK_WEEK = "#202020";
var COLOR_CAMPAIGN_HAPPY_WEEKEND = "#FE8C00";
var COLOR_NOTIF_SYSTEM_ERROR = "#C9372C";
var COLOR_NOTIF_SYSTEM_SUCCESS = "#20845A";
var COLOR_NOTIF_SYSTEM_ALERT = "#F6CC47";
var COLOR_NOTIF_SYSTEM_INFO = "#CDD5B5";
var COLOR_NOTIF_PUSH_HI_PRIMARY = "#E15300";
var COLOR_NOTIF_PUSH_HI_SECONDARY = "#E15300";
var COLOR_NOTIF_PUSH_HI_TERTIARY = "#E15300";
var COLOR_NOTIF_PUSH_WHY_PRIMARY = "#C4A175";
var COLOR_NOTIF_PUSH_WHY_SECONDARY = "#E4C6A0";
var COLOR_NOTIF_PUSH_WHY_TERTIARY = "#EEE1D2";
var COLOR_NOTIF_PUSH_MY_PRIMARY = "#FFE566";
var COLOR_NOTIF_PUSH_MY_SECONDARY = "#FFF496";
var COLOR_NOTIF_PUSH_MY_TERTIARY = "#FFE566";
var COLOR_NOTIF_PUSH_CRUISE_PRIMARY = "#B9DBDC";
var COLOR_NOTIF_PUSH_CRUISE_SECONDARY = "#CBE5E5";
var COLOR_NOTIF_PUSH_CRUISE_TERTIARY = "#E6F4F4";
var COLOR_NOTIF_NUDGE_PRIMARY = "#A1AB87";
var COLOR_NOTIF_TAG_SECONDARY = "#CDD5B5";
var COLOR_NOTIF_URGENCY_PRIMARY = "#A5D5D8";
var COLOR_ELEMENT_INPUT_ACTIVE = "#FF5E00";
var COLOR_ELEMENT_INPUT_ERROR = "#C9372C";
var COLOR_ELEMENT_INPUT_SUCCESS = "#20845A";
var COLOR_ELEMENT_INPUT_FORM_FIELD_ACTIVE = "#202020";
var COLOR_FOCUS_OUTLINE = "#005fcc";
var FONT_FAMILY_THOMAS_HEADLINE = "'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_FAMILY_SOURCE_SANS_PRO = "'Source Sans Pro', 'Trebuchet MS', Arial";
var FONT_FAMILY_NLTG_WAVE_SERIF = "'NLTG Wave Serif', Arial";
var FONT_FAMILY_RED_HAT_TEXT = "'Red Hat Text', Arial";
var FONT_FAMILY_GLOBETROTTER_SANS = "'Globetrotter Sans'";
var FONT_FAMILY_BODY = "'Source Sans Pro', 'Trebuchet MS', Arial";
var FONT_FAMILY_HEADLINE = "'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var APP_FONT_FAMILY_GLOBETROTTER_SANS_LIGHT = "GlobetrotterSansApp-Light";
var APP_FONT_FAMILY_GLOBETROTTER_SANS_MEDIUM = "GlobetrotterSansApp-Medium";
var APP_FONT_FAMILY_GLOBETROTTER_SANS_REGULAR = "GlobetrotterSansApp-Regular";
var APP_FONT_FAMILY_NLTG_WAVE_SERIF_REGULAR = "NLTGWaveSerif-Regular";
var APP_FONT_FAMILY_RED_HAT_TEXT_BOLD = "RedHatText-Bold";
var APP_FONT_FAMILY_RED_HAT_TEXT_BOLD_ITALIC = "RedHatText-BoldItalic";
var APP_FONT_FAMILY_RED_HAT_TEXT_ITALIC = "RedHatText-Italic";
var APP_FONT_FAMILY_RED_HAT_TEXT_LIGHT = "RedHatText-Light";
var APP_FONT_FAMILY_RED_HAT_TEXT_LIGHT_ITALIC = "RedHatText-LightItalic";
var APP_FONT_FAMILY_RED_HAT_TEXT_MEDIUM = "RedHatText-Medium";
var APP_FONT_FAMILY_RED_HAT_TEXT_MEDIUM_ITALIC = "RedHatText-MediumItalic";
var APP_FONT_FAMILY_RED_HAT_TEXT_REGULAR = "RedHatText-Regular";
var APP_FONT_FAMILY_RED_HAT_TEXT_SEMI_BOLD = "RedHatText-SemiBold";
var APP_FONT_FAMILY_RED_HAT_TEXT_SEMI_BOLD_ITALIC = "RedHatText-SemiBoldItalic";
var APP_FONT_FAMILY_SOURCE_SANS_PRO_BOLD = "SourceSansPro-Bold";
var APP_FONT_FAMILY_SOURCE_SANS_PRO_BOLD_ITALIC = "SourceSansPro-BoldIt";
var APP_FONT_FAMILY_SOURCE_SANS_PRO_ITALIC = "SourceSansPro-It";
var APP_FONT_FAMILY_SOURCE_SANS_PRO_REGULAR = "SourceSansPro-Regular";
var APP_FONT_FAMILY_THOMAS_HEADLINE_BOLD = "ThomasHeadline-Bold";
var APP_FONT_FAMILY_THOMAS_HEADLINE_BOLD_ITALIC = "ThomasHeadline-BoldItalic";
var APP_FONT_FAMILY_THOMAS_HEADLINE_REGULAR = "ThomasHeadline-Regular";
var ELEVATION_100 = "0 1px 2px 0 rgba(32, 32, 32, 0.10)";
var ELEVATION_200_APP = "0px 2px 4px 0px rgba(32, 32, 32, 0.11)";
var ELEVATION_300 = "0 3px 6px 0 rgba(32, 32, 32, 0.12)";
var ELEVATION_400 = "0 4px 8px 0 rgba(32, 32, 32, 0.13)";
var ELEVATION_400_APP = "0px 4px 8px 0px rgba(32, 32, 32, 0.13)";
var ELEVATION_900_APP = "0px 12px 24px 0px rgba(32, 32, 32, 0.21)";
var SPACE_50 = "2px";
var SPACE_100 = "4px";
var SPACE_200 = "8px";
var SPACE_300 = "12px";
var SPACE_400 = "16px";
var SPACE_500 = "24px";
var SPACE_600 = "40px";
var SPACE_700 = "48px";
var SPACE_800 = "60px";
var SPACE_900 = "80px";
var SPACE_950 = "120px";
var SPACE_1000 = "120px";
var SPACE_GRID_MARGIN_MOBILE = "16px";
var SPACE_GRID_MARGIN_TABLET = "24px";
var SPACE_GRID_MARGIN_DESKTOP = "28px";
var SPACE_GRID_GUTTER_MOBILE = "12px";
var SPACE_GRID_GUTTER_TABLET = "16px";
var SPACE_GRID_GUTTER_DESKTOP = "24px";
var SPACE_GRID_ROW_GAP_MOBILE = "24px";
var SPACE_GRID_ROW_GAP_TABLET = "24px";
var SPACE_GRID_ROW_GAP_DESKTOP = "24px";
var SPACE_APP_GRID_GUTTER = "12px";
var SPACE_APP_GRID_MARGIN = "16px";
var SPACE_APP_GRID_SWIM_LANES_XSMALL = "8px";
var SPACE_APP_GRID_SWIM_LANES_SMALL = "12px";
var SPACE_APP_GRID_SWIM_LANES_MEDIUM = "24px";
var SPACE_APP_GRID_SWIM_LANES_LARGE = "40px";
var SPACE_SECTION_MARGIN_MOBILE = "40px";
var SPACE_SECTION_MARGIN_TABLET = "60px";
var SPACE_SECTION_MARGIN_DESKTOP = "60px";
var APP_SPACE_50 = "2px";
var APP_SPACE_100 = "4px";
var APP_SPACE_200 = "8px";
var APP_SPACE_300 = "12px";
var APP_SPACE_400 = "16px";
var APP_SPACE_500 = "24px";
var APP_SPACE_600 = "32px";
var APP_SPACE_700 = "40px";
var TRANSITION = "calc(var(--transition-duration) * 0.25) ease";
var TRANSITION_SMOOTH = "calc(var(--transition-duration) * 0.5) ease";
var TRANSITION_SLOW = "calc(var(--transition-duration) * 1) ease";
var FONT_MEGA_DESKTOP = "400 7.2rem/1.1 'NLTG Wave Serif', Arial";
var FONT_MEGA_TABLET = "400 6.4rem/1.1 'NLTG Wave Serif', Arial";
var FONT_MEGA_MOBILE = "400 5.6rem/1.1 'NLTG Wave Serif', Arial";
var FONT_HEADLINE_XL_DESKTOP = "400 4rem/1.1 'NLTG Wave Serif', Arial";
var FONT_HEADLINE_XL_TABLET = "400 3.6rem/1.1 'NLTG Wave Serif', Arial";
var FONT_HEADLINE_XL_MOBILE = "400 3.4rem/1.1 'NLTG Wave Serif', Arial";
var FONT_HEADLINE_XL_APP = "400 34px/34px NLTGWaveSerif-Regular";
var FONT_HEADLINE_L_DESKTOP = "700 3.4rem/1 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_HEADLINE_L_TABLET = "700 3.2rem/1 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_HEADLINE_L_MOBILE = "700 2.6rem/1 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_HEADLINE_L_APP = "400 26px/25px ThomasHeadline-Bold";
var FONT_HEADLINE_M_DESKTOP = "700 2.6rem/1 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_HEADLINE_M_TABLET = "700 2.4rem/1 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_HEADLINE_M_MOBILE = "700 2.2rem/1 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_HEADLINE_M_APP = "400 22px/22px ThomasHeadline-Bold";
var FONT_HEADLINE_S_DESKTOP = "700 1.9rem/1.1 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_HEADLINE_S_TABLET = "700 1.9rem/1.1 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_HEADLINE_S_MOBILE = "700 1.9rem/1.1 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_HEADLINE_S_APP = "400 19px/19px ThomasHeadline-Bold";
var FONT_HEADLINE_XS_DESKTOP = "700 1.6rem/1.1 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_HEADLINE_XS_TABLET = "700 1.6rem/1.1 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_HEADLINE_XS_MOBILE = "700 1.6rem/1.1 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_HEADLINE_XS_APP = "400 16px/16px ThomasHeadline-Regular";
var FONT_BODY_L_DESKTOP = "400 2rem/normal 'Source Sans Pro', 'Trebuchet MS', Arial";
var FONT_BODY_L_TABLET = "400 2rem/normal 'Source Sans Pro', 'Trebuchet MS', Arial";
var FONT_BODY_L_MOBILE = "400 2rem/normal 'Source Sans Pro', 'Trebuchet MS', Arial";
var FONT_BODY_L_APP = "400 18px/21px SourceSansPro-Regular";
var FONT_BODY_M_DESKTOP = "400 1.6rem/1.35 'Source Sans Pro', 'Trebuchet MS', Arial";
var FONT_BODY_M_TABLET = "400 1.6rem/1.35 'Source Sans Pro', 'Trebuchet MS', Arial";
var FONT_BODY_M_MOBILE = "400 1.6rem/normal 'Source Sans Pro', 'Trebuchet MS', Arial";
var FONT_BODY_M_APP = "400 16px/22px SourceSansPro-Regular";
var FONT_BODY_S_DESKTOP = "400 1.4rem/1.4 'Source Sans Pro', 'Trebuchet MS', Arial";
var FONT_BODY_S_TABLET = "400 1.4rem/1.4 'Source Sans Pro', 'Trebuchet MS', Arial";
var FONT_BODY_S_MOBILE = "400 1.2rem/normal 'Source Sans Pro', 'Trebuchet MS', Arial";
var FONT_BODY_S_APP = "400 14px/17px SourceSansPro-Regular";
var FONT_BUTTON = "700 1.9rem/normal 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_BUTTON_APP = "400 19px/19px ThomasHeadline-Bold";
var FONT_MINI = "400 1.2rem/1.2 'Source Sans Pro', 'Trebuchet MS', Arial";
var FONT_MINI_APP = "400 12px/16px ThomasHeadline-Regular";
var FONT_SECTION_HEADING_DESKTOP = "400 3.2rem/1 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_SECTION_HEADING_TABLET = "400 3rem/1 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_SECTION_HEADING_MOBILE = "400 2.8rem/1 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var FONT_PREAMBLE = "400 2rem/1.3 'Thomas Headline', 'Source Sans 3', 'Tebuchet MS', 'Arial Black'";
var COLOR_DARK_CORE_2_500 = "#ff5e00";

export { APP_FONT_FAMILY_GLOBETROTTER_SANS_LIGHT, APP_FONT_FAMILY_GLOBETROTTER_SANS_MEDIUM, APP_FONT_FAMILY_GLOBETROTTER_SANS_REGULAR, APP_FONT_FAMILY_NLTG_WAVE_SERIF_REGULAR, APP_FONT_FAMILY_RED_HAT_TEXT_BOLD, APP_FONT_FAMILY_RED_HAT_TEXT_BOLD_ITALIC, APP_FONT_FAMILY_RED_HAT_TEXT_ITALIC, APP_FONT_FAMILY_RED_HAT_TEXT_LIGHT, APP_FONT_FAMILY_RED_HAT_TEXT_LIGHT_ITALIC, APP_FONT_FAMILY_RED_HAT_TEXT_MEDIUM, APP_FONT_FAMILY_RED_HAT_TEXT_MEDIUM_ITALIC, APP_FONT_FAMILY_RED_HAT_TEXT_REGULAR, APP_FONT_FAMILY_RED_HAT_TEXT_SEMI_BOLD, APP_FONT_FAMILY_RED_HAT_TEXT_SEMI_BOLD_ITALIC, APP_FONT_FAMILY_SOURCE_SANS_PRO_BOLD, APP_FONT_FAMILY_SOURCE_SANS_PRO_BOLD_ITALIC, APP_FONT_FAMILY_SOURCE_SANS_PRO_ITALIC, APP_FONT_FAMILY_SOURCE_SANS_PRO_REGULAR, APP_FONT_FAMILY_THOMAS_HEADLINE_BOLD, APP_FONT_FAMILY_THOMAS_HEADLINE_BOLD_ITALIC, APP_FONT_FAMILY_THOMAS_HEADLINE_REGULAR, APP_SPACE_100, APP_SPACE_200, APP_SPACE_300, APP_SPACE_400, APP_SPACE_50, APP_SPACE_500, APP_SPACE_600, APP_SPACE_700, BORDER_RADIUS_100, BORDER_RADIUS_200, BORDER_RADIUS_300, BORDER_RADIUS_400, BORDER_RADIUS_500, BORDER_RADIUS_600, BORDER_RADIUS_700, BORDER_RADIUS_800, BORDER_RADIUS_900, BORDER_RADIUS_CARD, BORDER_RADIUS_FULL_OR_NONE, BORDER_RADIUS_NONE, BORDER_RADIUS_PILL, COLOR_ALERT_500, COLOR_ALMOSTBLACK, COLOR_APRICOT_500, COLOR_BACKGROUND_BODY, COLOR_BACKGROUND_DISABLED, COLOR_BACKGROUND_SURFACE_PRIMARY, COLOR_BACKGROUND_SURFACE_SECONDARY, COLOR_BACKGROUND_SURFACE_TERTIARY, COLOR_BLACK, COLOR_BORDER_BRAND, COLOR_BORDER_DISABLED, COLOR_BORDER_KEY_LINE, COLOR_BORDER_PRIMARY, COLOR_BORDER_SECONDARY, COLOR_CAMPAIGN_BEST_PRIMARY, COLOR_CAMPAIGN_BETTER_PRIMARY, COLOR_CAMPAIGN_BETTER_SECONDARY, COLOR_CAMPAIGN_BLACK_WEEK, COLOR_CAMPAIGN_GOOD_PRIMARY, COLOR_CAMPAIGN_GOOD_SECONDARY, COLOR_CAMPAIGN_GOOD_TERTIARY, COLOR_CAMPAIGN_HAPPY_WEEKEND, COLOR_CLAY, COLOR_CORE_100, COLOR_CORE_200, COLOR_CORE_300, COLOR_CORE_400, COLOR_CORE_500, COLOR_CORE_600, COLOR_CORE_700, COLOR_CORE_800, COLOR_CORE_900, COLOR_CORE_SUNRISE, COLOR_CTA_BUTTON_GHOST, COLOR_CTA_BUTTON_PRIMARY, COLOR_CTA_BUTTON_PRIMARY_ACTIVE, COLOR_CTA_BUTTON_PRIMARY_DARK, COLOR_CTA_BUTTON_PRIMARY_DARK_ACTIVE, COLOR_CTA_BUTTON_PRIMARY_DARK_HOVER, COLOR_CTA_BUTTON_PRIMARY_HOVER, COLOR_CTA_BUTTON_SECONDARY, COLOR_CTA_BUTTON_SECONDARY_ACTIVE, COLOR_CTA_BUTTON_SECONDARY_DARK, COLOR_CTA_BUTTON_SECONDARY_DARK_ACTIVE, COLOR_CTA_BUTTON_SECONDARY_DARK_HOVER, COLOR_CTA_BUTTON_SECONDARY_HOVER, COLOR_CTA_BUTTON_SECONDARY_LIGHT, COLOR_CTA_BUTTON_SECONDARY_LIGHT_ACTIVE, COLOR_CTA_BUTTON_SECONDARY_LIGHT_HOVER, COLOR_CTA_BUTTON_TERTIARY, COLOR_CTA_BUTTON_TERTIARY_ACTIVE, COLOR_CTA_BUTTON_TERTIARY_HOVER, COLOR_CTA_LINK_PRIMARY, COLOR_CTA_LINK_PRIMARY_HOVER, COLOR_CTA_LINK_SECONDARY, COLOR_CTA_LINK_SECONDARY_HOVER, COLOR_CTA_PRIMARY, COLOR_CTA_PRIMARY_ACTIVE, COLOR_CTA_PRIMARY_HOVER, COLOR_CTA_SECONDARY, COLOR_CTA_SECONDARY_ACTIVE, COLOR_CTA_SECONDARY_HOVER, COLOR_DARK_CORE_100, COLOR_DARK_CORE_200, COLOR_DARK_CORE_2_500, COLOR_DARK_CORE_300, COLOR_DARK_CORE_400, COLOR_DARK_CORE_500, COLOR_DARK_CORE_600, COLOR_DARK_CORE_700, COLOR_DARK_CORE_800, COLOR_DARK_CORE_900, COLOR_DARK_GRAY, COLOR_DARK_GRAY_L1, COLOR_DARK_STEEL_BLUE, COLOR_EARTH, COLOR_ELEMENT_INPUT_ACTIVE, COLOR_ELEMENT_INPUT_ERROR, COLOR_ELEMENT_INPUT_FORM_FIELD_ACTIVE, COLOR_ELEMENT_INPUT_SUCCESS, COLOR_ERROR_500, COLOR_EXTRA_LIGHT_GRAY, COLOR_FOCUS_OUTLINE, COLOR_GRASS_100, COLOR_GRASS_200, COLOR_GRASS_300, COLOR_GRASS_400, COLOR_GRASS_500, COLOR_GRASS_600, COLOR_GRASS_700, COLOR_GRASS_800, COLOR_GRASS_900, COLOR_GREEN_100, COLOR_GREEN_200, COLOR_GREEN_300, COLOR_GREEN_400, COLOR_GREEN_500, COLOR_GREEN_600, COLOR_GREEN_700, COLOR_GREEN_800, COLOR_GREEN_900, COLOR_GREY_100, COLOR_GREY_200, COLOR_GREY_25, COLOR_GREY_300, COLOR_GREY_400, COLOR_GREY_50, COLOR_GREY_500, COLOR_GREY_600, COLOR_GREY_700, COLOR_GREY_800, COLOR_GREY_900, COLOR_LARIMAR_DARK_100, COLOR_LARIMAR_DARK_200, COLOR_LARIMAR_DARK_300, COLOR_LARIMAR_DARK_400, COLOR_LARIMAR_DARK_500, COLOR_LARIMAR_DARK_600, COLOR_LARIMAR_DARK_700, COLOR_LARIMAR_DARK_800, COLOR_LARIMAR_DARK_900, COLOR_LARIMAR_LIGHT_100, COLOR_LARIMAR_LIGHT_200, COLOR_LARIMAR_LIGHT_300, COLOR_LARIMAR_LIGHT_400, COLOR_LARIMAR_LIGHT_500, COLOR_LARIMAR_LIGHT_600, COLOR_LARIMAR_LIGHT_700, COLOR_LARIMAR_LIGHT_800, COLOR_LARIMAR_LIGHT_900, COLOR_LIGHT_GRAY, COLOR_LIGHT_GRAY_L1, COLOR_LIGHT_SAND, COLOR_LIGHT_TEAL, COLOR_LINK, COLOR_LINK_HOVER, COLOR_MANGO, COLOR_MEDIUM_GRAY, COLOR_MEDIUM_GRAY_L1, COLOR_MINT_GREEN_500, COLOR_MORGANITE_100, COLOR_MORGANITE_200, COLOR_MORGANITE_300, COLOR_MORGANITE_400, COLOR_MORGANITE_500, COLOR_MORGANITE_600, COLOR_MORGANITE_700, COLOR_MORGANITE_800, COLOR_MORGANITE_900, COLOR_NOTIF_NUDGE_PRIMARY, COLOR_NOTIF_PUSH_CRUISE_PRIMARY, COLOR_NOTIF_PUSH_CRUISE_SECONDARY, COLOR_NOTIF_PUSH_CRUISE_TERTIARY, COLOR_NOTIF_PUSH_HI_PRIMARY, COLOR_NOTIF_PUSH_HI_SECONDARY, COLOR_NOTIF_PUSH_HI_TERTIARY, COLOR_NOTIF_PUSH_MY_PRIMARY, COLOR_NOTIF_PUSH_MY_SECONDARY, COLOR_NOTIF_PUSH_MY_TERTIARY, COLOR_NOTIF_PUSH_WHY_PRIMARY, COLOR_NOTIF_PUSH_WHY_SECONDARY, COLOR_NOTIF_PUSH_WHY_TERTIARY, COLOR_NOTIF_SYSTEM_ALERT, COLOR_NOTIF_SYSTEM_ERROR, COLOR_NOTIF_SYSTEM_INFO, COLOR_NOTIF_SYSTEM_SUCCESS, COLOR_NOTIF_TAG_SECONDARY, COLOR_NOTIF_URGENCY_PRIMARY, COLOR_OCEAN, COLOR_OCEAN_L1, COLOR_OLIVE_100, COLOR_OLIVE_200, COLOR_OLIVE_300, COLOR_OLIVE_400, COLOR_OLIVE_500, COLOR_OLIVE_600, COLOR_OLIVE_700, COLOR_OLIVE_800, COLOR_OLIVE_900, COLOR_PLANT, COLOR_PYRIGHT_DARK_100, COLOR_PYRIGHT_DARK_200, COLOR_PYRIGHT_DARK_300, COLOR_PYRIGHT_DARK_400, COLOR_PYRIGHT_DARK_500, COLOR_PYRIGHT_DARK_600, COLOR_PYRIGHT_DARK_700, COLOR_PYRIGHT_DARK_800, COLOR_PYRIGHT_DARK_900, COLOR_PYRIGHT_LIGHT_100, COLOR_PYRIGHT_LIGHT_200, COLOR_PYRIGHT_LIGHT_300, COLOR_PYRIGHT_LIGHT_400, COLOR_PYRIGHT_LIGHT_500, COLOR_PYRIGHT_LIGHT_600, COLOR_PYRIGHT_LIGHT_700, COLOR_PYRIGHT_LIGHT_800, COLOR_PYRIGHT_LIGHT_900, COLOR_QUARTZ_100, COLOR_QUARTZ_150, COLOR_QUARTZ_200, COLOR_QUARTZ_250, COLOR_QUARTZ_300, COLOR_QUARTZ_350, COLOR_QUARTZ_400, COLOR_QUARTZ_450, COLOR_QUARTZ_50, COLOR_QUARTZ_500, COLOR_QUARTZ_550, COLOR_QUARTZ_600, COLOR_QUARTZ_650, COLOR_QUARTZ_700, COLOR_ROUGE_100, COLOR_ROUGE_200, COLOR_ROUGE_300, COLOR_ROUGE_400, COLOR_ROUGE_500, COLOR_ROUGE_600, COLOR_ROUGE_700, COLOR_ROUGE_800, COLOR_ROUGE_900, COLOR_RUBY_100, COLOR_RUBY_200, COLOR_RUBY_300, COLOR_RUBY_400, COLOR_RUBY_500, COLOR_RUBY_600, COLOR_RUBY_700, COLOR_RUBY_800, COLOR_RUBY_900, COLOR_SALMON_500, COLOR_SANDSTONE, COLOR_SAND_100, COLOR_SAND_200, COLOR_SAND_300, COLOR_SAND_400, COLOR_SAND_500, COLOR_SAND_600, COLOR_SAND_700, COLOR_SAND_800, COLOR_SAND_900, COLOR_SILVER, COLOR_STEEL_BLUE, COLOR_SUCCESS_500, COLOR_SUNLIGHT_100, COLOR_SUNLIGHT_200, COLOR_SUNLIGHT_300, COLOR_SUNLIGHT_400, COLOR_SUNLIGHT_500, COLOR_SUNLIGHT_600, COLOR_SUNLIGHT_700, COLOR_SUNLIGHT_800, COLOR_SUNLIGHT_900, COLOR_TEAL_100, COLOR_TEAL_200, COLOR_TEAL_300, COLOR_TEAL_400, COLOR_TEAL_500, COLOR_TEAL_600, COLOR_TEAL_700, COLOR_TEAL_800, COLOR_TEAL_900, COLOR_TEXT, COLOR_TEXT_DISABLED, COLOR_TEXT_INVERSE, COLOR_TEXT_PRIMARY, COLOR_TEXT_SUBTLE, COLOR_TURMERIC_100, COLOR_TURMERIC_200, COLOR_TURMERIC_300, COLOR_TURMERIC_400, COLOR_TURMERIC_500, COLOR_TURMERIC_600, COLOR_TURMERIC_700, COLOR_TURMERIC_800, COLOR_TURMERIC_900, COLOR_WAVE, COLOR_WHITE, ELEVATION_100, ELEVATION_200_APP, ELEVATION_300, ELEVATION_400, ELEVATION_400_APP, ELEVATION_900_APP, FONT_BODY_L_APP, FONT_BODY_L_DESKTOP, FONT_BODY_L_MOBILE, FONT_BODY_L_TABLET, FONT_BODY_M_APP, FONT_BODY_M_DESKTOP, FONT_BODY_M_MOBILE, FONT_BODY_M_TABLET, FONT_BODY_S_APP, FONT_BODY_S_DESKTOP, FONT_BODY_S_MOBILE, FONT_BODY_S_TABLET, FONT_BUTTON, FONT_BUTTON_APP, FONT_FAMILY_BODY, FONT_FAMILY_GLOBETROTTER_SANS, FONT_FAMILY_HEADLINE, FONT_FAMILY_NLTG_WAVE_SERIF, FONT_FAMILY_RED_HAT_TEXT, FONT_FAMILY_SOURCE_SANS_PRO, FONT_FAMILY_THOMAS_HEADLINE, FONT_HEADLINE_L_APP, FONT_HEADLINE_L_DESKTOP, FONT_HEADLINE_L_MOBILE, FONT_HEADLINE_L_TABLET, FONT_HEADLINE_M_APP, FONT_HEADLINE_M_DESKTOP, FONT_HEADLINE_M_MOBILE, FONT_HEADLINE_M_TABLET, FONT_HEADLINE_S_APP, FONT_HEADLINE_S_DESKTOP, FONT_HEADLINE_S_MOBILE, FONT_HEADLINE_S_TABLET, FONT_HEADLINE_XL_APP, FONT_HEADLINE_XL_DESKTOP, FONT_HEADLINE_XL_MOBILE, FONT_HEADLINE_XL_TABLET, FONT_HEADLINE_XS_APP, FONT_HEADLINE_XS_DESKTOP, FONT_HEADLINE_XS_MOBILE, FONT_HEADLINE_XS_TABLET, FONT_MEGA_DESKTOP, FONT_MEGA_MOBILE, FONT_MEGA_TABLET, FONT_MINI, FONT_MINI_APP, FONT_PREAMBLE, FONT_SECTION_HEADING_DESKTOP, FONT_SECTION_HEADING_MOBILE, FONT_SECTION_HEADING_TABLET, SPACE_100, SPACE_1000, SPACE_200, SPACE_300, SPACE_400, SPACE_50, SPACE_500, SPACE_600, SPACE_700, SPACE_800, SPACE_900, SPACE_950, SPACE_APP_GRID_GUTTER, SPACE_APP_GRID_MARGIN, SPACE_APP_GRID_SWIM_LANES_LARGE, SPACE_APP_GRID_SWIM_LANES_MEDIUM, SPACE_APP_GRID_SWIM_LANES_SMALL, SPACE_APP_GRID_SWIM_LANES_XSMALL, SPACE_GRID_GUTTER_DESKTOP, SPACE_GRID_GUTTER_MOBILE, SPACE_GRID_GUTTER_TABLET, SPACE_GRID_MARGIN_DESKTOP, SPACE_GRID_MARGIN_MOBILE, SPACE_GRID_MARGIN_TABLET, SPACE_GRID_ROW_GAP_DESKTOP, SPACE_GRID_ROW_GAP_MOBILE, SPACE_GRID_ROW_GAP_TABLET, SPACE_SECTION_MARGIN_DESKTOP, SPACE_SECTION_MARGIN_MOBILE, SPACE_SECTION_MARGIN_TABLET, TRANSITION, TRANSITION_SLOW, TRANSITION_SMOOTH };
//# sourceMappingURL=variables.default.js.map
